import { render, staticRenderFns } from "./AccountantsSubmenu.vue?vue&type=template&id=960398b0&"
import script from "./AccountantsSubmenu.vue?vue&type=script&lang=js&"
export * from "./AccountantsSubmenu.vue?vue&type=script&lang=js&"
import style0 from "./AccountantsSubmenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports